export interface ContactFormData {
  fullname: string;
  email: string;
  message: string;
}

interface ApiResponse {
  success: boolean;
  message: string;
  errors?: any;
}

export const useContactForm = () => {
  const isSubmitting = ref(false);
  const responseMessage = ref("");
  const hasError = ref(false);

  const submitForm = async (data: ContactFormData) => {
    isSubmitting.value = true;
    responseMessage.value = "";
    hasError.value = false;

    try {
      const response = await $fetch<ApiResponse>("/api/contact", {
        method: "POST",
        body: data,
      });

      if (response.success) {
        responseMessage.value = response.message;
        hasError.value = false;
        return { success: true };
      } else {
        responseMessage.value = response.message;
        hasError.value = true;
        return { success: false };
      }
    } catch (error: any) {
      console.error("Erreur:", error);
      hasError.value = true;
      responseMessage.value = "Une erreur est survenue";
      return { success: false };
    } finally {
      isSubmitting.value = false;
    }
  };

  const resetForm = () => {
    responseMessage.value = "";
    hasError.value = false;
  };

  return {
    submitForm,
    resetForm,
    isSubmitting: readonly(isSubmitting),
    responseMessage: readonly(responseMessage),
    hasError: readonly(hasError),
  };
};
